export const paymentMethods = [
    { name: 'Invoicing', code: 'invoicing' },
    { name: 'Automatic Payment', code: 'automatic_payment' },
    { name: 'Request Payment', code: 'request_payment' },
];

export const getPaymentMethodSeverity = (method) => {
    switch (method?.toLowerCase()) {
        case 'invoicing':
            return 'info';      // Blue
        case 'automatic payment':
            return 'success';   // Green
        case 'request payment':
            return 'warning';   // Orange
        default:
            return 'danger';    // Red
    }
};

export const getPaymentMethodName = (code) => {
    const method = paymentMethods.find(method => method.code === code);
    return method ? method.name : 'Unknown';
}; 